import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableBodyComponent, dataTableBodyTemplate } from './DataTableBody';
import styles from './DataTableBody.styles.scss';
export const dataTableBodyDefinition = {
    baseName: 'data-table-body',
    template: dataTableBodyTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonDataTableBody = DataTableBodyComponent.compose(dataTableBodyDefinition);
